<template>
  <div class="form__field-holder"
       :class="{'form__field-holder_error': !!errors.has(newName)}"
       data-vv-value-path="model"
       :data-vv-as="label">
    <div class="form__field-box">
      <label class="form__label" v-if="showLabel && labelHtml" v-html="labelHtml"></label>
      <label class="form__label" v-else-if="showLabel">
        {{ label }}
      </label>
      <textarea class="form__textfield form__textarea"
                :class="{ 'v-input__field--is-small': small, 'no-resize': noResize }"
                v-model="model"
                :name="name"
                :disabled="disabled"
                :placeholder="placeholder"
                :rows="rows"
                @change="$emit('input', model)">
      </textarea>
    </div>
    <div class="form__field-error" v-if="errors.has(newName)">
      {{ errors.first(newName) }}
    </div>
  </div>
</template>

<script>
  import field from '../mixins/field'

  export default {
    mixins: [field],
    props: {
      small: {
        default: false,
        type: Boolean
      },
      placeholder: {
        default: null,
        type: String
      },
      labelHtml: {
        default() {
          return ''
        },
        type: String
      },
      showLabel: {
        default: true,
        type: Boolean
      },
      noResize: {
        default: false,
        type: Boolean
      },
      rows: {
        default: 2,
        type: Number
      }
    }
  }
</script>